module.exports = {

    siteTitleMeta: `1REport`,
    siteDescriptionMeta: `The new way to list a real estate property, market your goods and services, mine your leads and increase revenue.`,
    shareImageWidth: 1000,
    shareImageHeight: 523
}
